import { PeriodField } from './period/PeriodPicker';

// El rango de fechas de los filtros. P-075: es el selector global de periodos (`PeriodField`) con el
// contrato de siempre, para que las pantallas que lo usan no cambien nada de lo que piden:
//   · los valores viajan como 'YYYY-MM-DD' y vacío = sin límite;
//   · «hoy» es el día del equipo, como lo tomaba el calendario anterior;
//   · `allowClear` ofrece «Todas las fechas» (sin límite) donde ya se ofrecía;
//   · `maxToday` impide elegir días futuros donde ya se impedía (sin él, se pueden elegir, como antes).
// Lo que cambia es cómo se elige: atajos (Hoy · Ayer · Antier · Últimos 7 días · Este mes) y «Otro
// periodo» con Día | Semana | Mes | Personalizado y UN solo calendario de rango.
export function DateRangeField({ from, to, onChange, label = 'Fechas', allowClear = true, maxToday = false, disabled = false }: {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
  label?: string;
  allowClear?: boolean;
  maxToday?: boolean;
  disabled?: boolean;
}) {
  return (
    <PeriodField
      allowAll={allowClear}
      allowFuture={!maxToday}
      className="date-range"
      disabled={disabled}
      label={label}
      onChange={(range) => onChange(range.from, range.to)}
      value={{ from, to }}
    />
  );
}
